"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.dayDatumPropTypes = void 0;
exports.formatDate = formatDate;
exports.propTypes = exports.imDataPropTypes = void 0;
exports.shouldComponentUpdate = shouldComponentUpdate;
var T = _interopRequireWildcard(require("prop-types"));
var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));
var _immutable = _interopRequireDefault(require("immutable"));
var _lodash = require("lodash");
var _intl = _interopRequireDefault(require("intl"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Commonly shared resources for chart components
// Terrible solution... I know
require('intl/locale-data/jsonp/en');
require('intl/locale-data/jsonp/es');
require('intl/locale-data/jsonp/ru');
function formatDate(ts, lang, options = {}) {
  const date = new Date(ts);
  return new _intl.default.DateTimeFormat(lang, options).format(date);
}
const dayDatumPropTypes = exports.dayDatumPropTypes = {
  periodStart: T.string.isRequired,
  val: T.number.isRequired
};
const imDataPropTypes = exports.imDataPropTypes = _reactImmutableProptypes.default.listOf(_reactImmutableProptypes.default.contains(dayDatumPropTypes));
const propTypes = exports.propTypes = {
  title: T.string,
  titleId: T.string,
  lang: T.string.isRequired,
  precision: T.number,
  unitType: T.string.isRequired,
  isLoading: T.bool.isRequired,
  imData: imDataPropTypes
};
const defaultProps = exports.defaultProps = {
  isLoading: false
};
function shouldComponentUpdate(nextProps) {
  if (this.props.isLoading !== nextProps.isLoading) {
    return true;
  }
  if (_immutable.default.is(this.props.imData, nextProps.imData)) {
    return false;
  }
  // If immutable is still forcing updates too often then look into making all the structures immutable structures
  // http://stackoverflow.com/questions/32913458/immutable-js-compare-nested-structures
  // TODO: check efficiency of this
  return true;
}